/* CP tapestry viewer: drag/scroll/keys to move, scene jumps, zoom, mini map, full screen */
(function () {
  var ZOOMS = [1, 1.6, 2.4];
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';

    var viewer = root.querySelector('[data-viewer]');
    var track = root.querySelector('[data-track]');
    var frame = root.querySelector('[data-frame]');
    var map = root.querySelector('[data-map]');
    var win = root.querySelector('[data-map-window]');
    var countEl = root.querySelector('[data-count]');
    var titleEl = root.querySelector('[data-title]');
    var shopEl = root.querySelector('[data-shop]');
    var prevBtn = root.querySelector('[data-prev]');
    var nextBtn = root.querySelector('[data-next]');
    var zoomIn = root.querySelector('[data-zoom-in]');
    var zoomOut = root.querySelector('[data-zoom-out]');
    var fsBtn = root.querySelector('[data-fullscreen]');
    var markers = [].slice.call(root.querySelectorAll('[data-marker]'));
    var items = [].slice.call(root.querySelectorAll('[data-scene]'));
    var scenes = items.map(function (el, i) {
      return {
        el: el,
        marker: markers[i],
        pos: parseFloat(el.dataset.position) || 0,
        title: el.dataset.title,
        shopUrl: el.dataset.shopUrl,
        shopLabel: el.dataset.shopLabel
      };
    });
    var zoomIndex = 0;
    var current = -1;

    function behavior() {
      return reduceMotion ? 'auto' : 'smooth';
    }

    /* Position helpers: fraction (0..1) of the artwork at the centre of the view */
    function centreFraction() {
      var w = viewer.scrollWidth;
      return w ? (viewer.scrollLeft + viewer.clientWidth / 2) / w : 0;
    }

    function goToFraction(f, smooth) {
      var left = Math.max(0, f * viewer.scrollWidth - viewer.clientWidth / 2);
      /* Glide over short distances; jump straight there over long ones */
      var far = Math.abs(left - viewer.scrollLeft) > viewer.clientWidth * 2;
      viewer.scrollTo({ left: left, behavior: smooth === false || far ? 'auto' : behavior() });
    }

    /* Active scene = the last scene whose caption is at or left of the centre (with a little lead) */
    function sceneAt(f) {
      var pct = f * 100 + 1.5;
      var idx = 0;
      for (var i = 0; i < scenes.length; i++) if (scenes[i].pos <= pct) idx = i;
      return idx;
    }

    function setActive(idx) {
      if (!scenes.length || idx === current) return;
      if (current > -1) {
        scenes[current].el.classList.remove('is-active');
        if (scenes[current].marker) scenes[current].marker.classList.remove('is-active');
      }
      current = idx;
      var s = scenes[idx];
      s.el.classList.add('is-active');
      if (s.marker) s.marker.classList.add('is-active');
      countEl.textContent = 'Scene ' + (idx + 1) + ' of ' + scenes.length;
      titleEl.textContent = s.title;
      if (s.shopUrl) {
        shopEl.href = s.shopUrl;
        shopEl.textContent = 'Shop ' + s.shopLabel;
        shopEl.hidden = false;
      } else {
        shopEl.hidden = true;
      }
      prevBtn.disabled = idx === 0;
      nextBtn.disabled = idx === scenes.length - 1;
    }

    function updateMap() {
      var w = viewer.scrollWidth;
      if (!w || !win) return;
      win.style.left = (viewer.scrollLeft / w) * 100 + '%';
      win.style.width = Math.min(100, (viewer.clientWidth / w) * 100) + '%';
    }

    var ticking = false;
    var lastFraction = 0;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        lastFraction = centreFraction();
        updateMap();
        setActive(sceneAt(lastFraction));
        ticking = false;
      });
    }

    /* Keep the same point in view when the window or orientation changes */
    var resizeTimer;
    function onResize() {
      var f = lastFraction;
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        goToFraction(f, false);
        updateMap();
      }, 120);
    }

    function jumpTo(idx) {
      idx = Math.max(0, Math.min(scenes.length - 1, idx));
      goToFraction(scenes[idx].pos / 100);
      setActive(idx);
    }

    /* Drag to pan with a mouse (touch and trackpads use native scrolling) */
    var drag = null;
    viewer.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      drag = { x: e.clientX, y: e.clientY, left: viewer.scrollLeft, top: viewer.scrollTop, moved: false };
      viewer.setPointerCapture(e.pointerId);
    });
    viewer.addEventListener('pointermove', function (e) {
      if (!drag) return;
      var dx = e.clientX - drag.x;
      var dy = e.clientY - drag.y;
      if (!drag.moved && Math.abs(dx) + Math.abs(dy) > 3) {
        drag.moved = true;
        viewer.classList.add('is-dragging');
      }
      viewer.scrollLeft = drag.left - dx;
      viewer.scrollTop = drag.top - dy;
    });
    function endDrag() {
      drag = null;
      viewer.classList.remove('is-dragging');
    }
    viewer.addEventListener('pointerup', endDrag);
    viewer.addEventListener('pointercancel', endDrag);

    /* Vertical mouse wheel moves along the tapestry until either end is reached */
    viewer.addEventListener(
      'wheel',
      function (e) {
        if (e.ctrlKey || Math.abs(e.deltaX) > Math.abs(e.deltaY)) return;
        if (zoomIndex > 0) return; /* zoomed in: wheel scrolls vertically as normal */
        var max = viewer.scrollWidth - viewer.clientWidth;
        var atStart = viewer.scrollLeft <= 0 && e.deltaY < 0;
        var atEnd = viewer.scrollLeft >= max - 1 && e.deltaY > 0;
        if (atStart || atEnd) return;
        e.preventDefault();
        viewer.scrollLeft += e.deltaY;
      },
      { passive: false }
    );

    /* Keyboard */
    viewer.addEventListener('keydown', function (e) {
      var step = viewer.clientWidth * 0.4;
      if (e.key === 'ArrowRight') viewer.scrollBy({ left: step, behavior: behavior() });
      else if (e.key === 'ArrowLeft') viewer.scrollBy({ left: -step, behavior: behavior() });
      else if (e.key === 'Home') viewer.scrollTo({ left: 0, behavior: behavior() });
      else if (e.key === 'End') viewer.scrollTo({ left: viewer.scrollWidth, behavior: behavior() });
      else if (e.key === '+' || e.key === '=') setZoom(zoomIndex + 1);
      else if (e.key === '-') setZoom(zoomIndex - 1);
      else return;
      e.preventDefault();
    });

    /* Zoom keeps the same point in the middle of the view */
    function setZoom(i) {
      i = Math.max(0, Math.min(ZOOMS.length - 1, i));
      if (i === zoomIndex) return;
      var fx = centreFraction();
      var fy = viewer.scrollHeight ? (viewer.scrollTop + viewer.clientHeight / 2) / viewer.scrollHeight : 0.5;
      zoomIndex = i;
      root.style.setProperty('--cp-tap-zoom', ZOOMS[i]);
      zoomIn.disabled = i === ZOOMS.length - 1;
      zoomOut.disabled = i === 0;
      /* Reading scrollWidth applies the new size straight away, so position in the same task */
      goToFraction(fx, false);
      viewer.scrollTop = Math.max(0, fy * viewer.scrollHeight - viewer.clientHeight / 2);
      lastFraction = fx;
      updateMap();
    }
    zoomIn.addEventListener('click', function () { setZoom(zoomIndex + 1); });
    zoomOut.addEventListener('click', function () { setZoom(zoomIndex - 1); });
    zoomOut.disabled = true;

    /* Scene buttons */
    prevBtn.addEventListener('click', function () { jumpTo(current - 1); });
    nextBtn.addEventListener('click', function () { jumpTo(current + 1); });
    items.forEach(function (el, i) {
      var b = el.querySelector('[data-jump]');
      if (!b) return;
      b.addEventListener('click', function () {
        jumpTo(i);
        var top = frame.getBoundingClientRect().top + window.pageYOffset - 120;
        window.scrollTo({ top: Math.max(0, top), behavior: behavior() });
        viewer.focus({ preventScroll: true });
      });
    });

    /* Mini map: click or drag to move the view */
    if (map) {
      var mapDrag = false;
      function mapTo(e) {
        var r = map.getBoundingClientRect();
        goToFraction(Math.max(0, Math.min(1, (e.clientX - r.left) / r.width)), false);
      }
      map.addEventListener('pointerdown', function (e) {
        mapDrag = true;
        map.setPointerCapture(e.pointerId);
        mapTo(e);
      });
      map.addEventListener('pointermove', function (e) { if (mapDrag) mapTo(e); });
      map.addEventListener('pointerup', function () { mapDrag = false; });
      map.addEventListener('pointercancel', function () { mapDrag = false; });
    }

    /* Full screen where supported */
    if (fsBtn && frame.requestFullscreen) {
      fsBtn.hidden = false;
      fsBtn.addEventListener('click', function () {
        if (document.fullscreenElement) document.exitFullscreen();
        else frame.requestFullscreen();
      });
      document.addEventListener('fullscreenchange', function () {
        var on = document.fullscreenElement === frame;
        fsBtn.setAttribute('aria-label', on ? 'Exit full screen' : 'Full screen');
        requestAnimationFrame(updateMap);
      });
    }

    viewer.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onResize);
    if (scenes.length) setActive(0);
    else {
      prevBtn.hidden = nextBtn.hidden = true;
    }
    updateMap();
    [].forEach.call(track.querySelectorAll('img'), function (img) {
      if (!img.complete) img.addEventListener('load', updateMap, { once: true });
    });
  }

  function boot() {
    [].forEach.call(document.querySelectorAll('[data-cp-tapestry]'), init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
